import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const InvestirPage = lazy(() => import('../pages/investir/page'));
const ProjetosPage = lazy(() => import('../pages/projetos/page'));
const ProjetoDetailPage = lazy(() => import('../pages/projetos/[id]/page'));
const ConteudoPage = lazy(() => import('../pages/conteudo/page'));
const BlogPostPage = lazy(() => import('../pages/conteudo/[slug]/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));
const TermosPage = lazy(() => import('../pages/termos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/investir',
    element: <InvestirPage />,
  },
  {
    path: '/projetos',
    element: <ProjetosPage />,
  },
  {
    path: '/projetos/:id',
    element: <ProjetoDetailPage />,
  },
  {
    path: '/conteudo',
    element: <ConteudoPage />,
  },
  {
    path: '/conteudo/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />,
  },
  {
    path: '/termos',
    element: <TermosPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
